var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sider-list-1',{ref:"side"}),_c('div',{ref:"content",staticClass:"home-content"},[_c('router-view')],1),(_vm.isShowAgreement2)?_c('infoAction',{ref:"agreementCom2",attrs:{"type":4},on:{"suerAgree":_vm.suerAgree2}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }